import React from "react";
import { CheckIcon } from "lucide-react";
import { TRUST_POINTS } from "../../data/site";
export function TrustStrip() {
  return <section aria-label="Why owners trust NEXORA" className="border-y border-line bg-line" data-id="element-216" data-mp="3l5ba4qp1h0d8">
      <ul className="grid grid-cols-1 gap-px sm:grid-cols-2 xl:grid-cols-4" data-id="element-217" data-mp="3h62ipshh1eku">
        {TRUST_POINTS.map(t => <li key={t} className="flex min-h-[76px] items-center gap-3 bg-ink-2 px-[clamp(1.25rem,2.5vw,3rem)] py-4 text-[15px] text-fg-2" data-id="element-218" data-mp="3c80vqwgxcv43">
            <CheckIcon className="h-4 w-4 shrink-0 text-accent-soft" aria-hidden data-id="element-219" data-mp="8ppt8mfgwp1w" />
            {t}
          </li>)}
      </ul>
    </section>;
}